import React from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import utils from '../utils'
import QuoteForm from '../components/home/QuoteForm'
import { LuBadgeCheck, LuCompass, LuLightbulb, LuHelpingHand } from "react-icons/lu";
import { LuFileBadge, LuShieldCheck } from "react-icons/lu";
import office from '../assets/office.png'


const CertificationSection = () => {
    return (
        <section className="container mx-auto px-3 py-16">
            <div className="bg-surface-container p-12 rounded-3xl flex flex-col md:flex-row items-center justify-between gap-12 border border-outline-variant/10">
                <div className="max-w-md text-center md:text-left">
                    <h2 className="text-2xl font-black text-on-surface mb-4 uppercase tracking-tight">
                        Certified Excellence
                    </h2>
                    <p className="text-on-surface-variant leading-relaxed">
                        We maintain the highest levels of professional accreditation to ensure
                        the safety and legality of your engineering projects.
                    </p>
                </div>

                <div className="flex flex-wrap justify-center gap-12">
                    <div className="group flex flex-col items-center gap-4 p-6 bg-white rounded-2xl shadow-sm border border-outline-variant/20 transition-all duration-300 hover:shadow-md">
                        <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all">
                            <LuFileBadge size={32} />
                        </div>
                        <div className="text-center">
                            <span className="block text-[10px] font-black uppercase tracking-[0.2em] text-on-surface-variant mb-1">
                                Licensed NCA
                            </span>
                            <p className="text-sm font-black text-primary">
                                REG: 93437/B/0525
                            </p>
                        </div>
                    </div>

                    <div className="hidden md:flex flex-col items-center justify-center opacity-20">
                        <LuShieldCheck size={48} className="text-on-surface-variant" />
                    </div>
                </div>
            </div>
        </section>
    );
};

const CTASection = (props) => {
    return (
        <section className="py-20 ">
            <div className="container mx-auto px-3 bg-primary rounded-3xl p-12 md:p-20 text-center text-white relative overflow-hidden shadow-2xl shadow-primary/20">
                <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -mr-32 -mt-32 blur-2xl"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 bg-black/10 rounded-full -ml-24 -mb-24 blur-xl"></div>

                <div className="relative z-10">
                    <h2 className="text-3xl md:text-5xl font-headline font-black mb-6">
                        Let's Build Something Great Together
                    </h2>

                    <p className="text-white/90 mb-10 max-w-xl mx-auto text-lg">
                        Ready to build something great? Let’s partner and transform your vision into a successful project.
                        <br />
                        Jahtech Construction,
                        Turning every vision into a lasting landmark!
                    </p>

                    <button
                        onClick={() => props.openModal()}
                        className="bg-white text-primary px-10 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-all active:scale-95 duration-200 shadow-lg shadow-black/10">
                        Start Your Project
                    </button>
                </div>
            </div>
        </section>
    );
};


const PillarsOfSuccess = () => {
    const pillars = [
        {
            title: "Integrity",
            desc: "Uncompromising honesty and ethical standards in every consultation and contract we manage.",
            icon: <LuBadgeCheck size={24} />,
        },
        {
            title: "Quality",
            desc: "Precision-engineered solutions that exceed international building standards and safety codes.",
            icon: <LuCompass size={24} />,
        },
        {
            title: "Innovation",
            desc: "Leveraging cutting-edge BIM modeling and smart-material data to optimize construction workflows.",
            icon: <LuLightbulb size={24} />,
        },
        {
            title: "Client Focus",
            desc: "A collaborative approach that prioritizes your project goals, timelines, and financial objectives.",
            icon: <LuHelpingHand size={24} />,
        },
    ];

    return (
        <section className="bg-surface-container-lowest py-16">
            <div className="container mx-auto px-3">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-headline font-black text-on-surface mb-4 uppercase tracking-tight">
                        The Pillars of Our Success
                    </h2>
                    <div className="h-1.5 w-20 bg-primary mx-auto rounded-full"></div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {pillars.map((pillar, index) => (
                        <div
                            key={index}
                            className="bg-white p-8 rounded-2xl shadow-[0_20px_40px_-15px_rgba(26,42,74,0.05)] border border-outline-variant/30 hover:border-primary transition-all duration-300 group"
                        >
                            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-6 text-primary group-hover:bg-primary group-hover:text-white transition-all duration-300">
                                {pillar.icon}
                            </div>
                            <h3 className="text-xl font-bold text-on-surface mb-3">
                                {pillar.title}
                            </h3>
                            <p className="text-on-surface-variant text-sm leading-relaxed">
                                {pillar.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

function AboutPage() {
    const url = window.location.href
    function openModal() {
        const openBtn = document.getElementById("contact-modal-open-btn")
        openBtn.click()
    }
    return (
        <HelmetProvider>
            <Helmet>
                <title>About Us - {utils.siteName}</title>
                <link rel="canonical" href={url} />
            </Helmet>
            <div>
                <QuoteForm />
                <section className="relative h-[400px] flex items-center justify-center overflow-hidden bg-surface-container-low">
                    <div className="absolute inset-0 opacity-10 pointer-events-none">
                        <div
                            className="absolute inset-0 opacity-5"
                            style={{
                                backgroundImage: 'linear-gradient(#005baf 1px, transparent 1px), linear-gradient(90deg, #005baf 1px, transparent 1px)',
                                backgroundSize: '100px 100px'
                            }}
                        ></div>
                    </div>
                    <div className="relative z-10 text-center px-8">
                        <div className="inline-block px-4 py-1.5 mb-6 rounded-full bg-primary/5 border border-primary/10">
                            <span className="text-xs font-bold uppercase tracking-[0.2em] text-primary">
                                Est. 2021
                            </span>
                        </div>
                        <h1 className="text-3xl md:text-5xl font-headline font-black tracking-tight text-on-surface mb-6 leading-[1.1]">
                            About Jahtech <br className="hidden md:block" /> Construction Consultants
                        </h1>
                        <p className="text-lg md:text-xl text-on-surface-variant max-w-2xl mx-auto leading-relaxed">
                            We deliver smart construction solutions through expert planning, design, and project management—turning visions into reality with precision and quality.
                        </p>
                    </div>
                    <div className="absolute -top-24 -right-24 w-96 h-36 bg-primary/5 rounded-full blur-3xl"></div>
                    <div className="absolute -bottom-24 -left-24 w-96 h-36 bg-primary/5 rounded-full blur-3xl"></div>
                </section>
                <section className="container mx-auto py-16 px-3">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                        <div className="rounded-2xl overflow-hidden shadow-2xl border border-outline-variant/10">
                            <img
                                alt="Jahtech Main Office"
                                className="w-full h-[500px] object-cover"
                                src={office}
                            />
                        </div>

                        <div className="space-y-8">
                            <div>
                                <h2 className="text-3xl font-headline font-black text-on-surface mb-6">
                                    Our Mission & Values
                                </h2>
                                <p className="text-on-surface-variant leading-relaxed text-lg mb-4">
                                    Our mission is to deliver innovative, efficient, and reliable construction consultancy services that
                                    transform ideas into high-quality built environments through expert planning, design, and project execution support.
                                </p>
                                <p className="text-on-surface-variant leading-relaxed text-lg">
                                    We uphold integrity, excellence, innovation, reliability, client focus, and professionalism in every project we undertake.
                                </p>
                            </div>

                            <div className="grid grid-cols-2 gap-8 pt-4">
                                <div>
                                    <div className="text-primary font-black text-4xl mb-2">20+</div>
                                    <div className="text-on-surface-variant text-sm font-bold uppercase tracking-wider">
                                        Projects Completed
                                    </div>
                                </div>
                                <div>
                                    <div className="text-primary font-black text-4xl mb-2">4</div>
                                    <div className="text-on-surface-variant text-sm font-bold uppercase tracking-wider">
                                        Years Experience
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <PillarsOfSuccess />
                <CertificationSection />
                <div className="">
                    <CTASection openModal={openModal} />
                </div>
            </div>
        </HelmetProvider>
    )
}

export default AboutPage